import React from 'react';
import ToastBase from './ToastBase';

import TToast from './@types/TToast';
import TEFeedbackSignal from '../../types/TEFeedbackSignal';

const Error = ({ children, icon, ...rest }: TToast) => (
  <ToastBase signal={TEFeedbackSignal.Error} icon={icon} {...rest}>
    {children}
  </ToastBase>
);

export default Error;
